// @ts-ignore
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
/**
 *
 * @param {string} link A URL Reference to a Breadcrumb item
 * @param {string} name A Name for the breadcrumb link ite, used as link text
 */
export namespace Navigation {
	let isTouchDevice = () => {
		return window.matchMedia("(pointer: coarse)").matches
	}

	let setupNav = () => {
		let $siteNav = $('.js-site-nav');
		let $mainNav = $('.js-main-nav');

		// Lock or Unlock Body Scroll based on if dropdown menu is open
		const targetNode = document.querySelector('.js-site-nav');
		const secondaryTargetNode = document.querySelector('.js-search-container');

		if(targetNode) {
			const config = { attributes: true };
			const callback = function(mutationsList, observer) {
				for(const mutation of mutationsList) {
					if (mutation.type === 'attributes') {
						if(window.matchMedia('(max-width: 767px)') && (mutation.target.classList.contains('state-visible') || secondaryTargetNode.classList.contains('state-visible'))) {
							disableBodyScroll(mutation.target);
						} else {
							enableBodyScroll(mutation.target);
						}
					}
				}
			};

			const observer = new MutationObserver(callback);
			observer.observe(targetNode, config);
		}

		if(secondaryTargetNode) {
			const config = { attributes: true };
			const callback = function(mutationsList, observer) {
				for(const mutation of mutationsList) {
					if (mutation.type === 'attributes') {
						if(window.matchMedia('(max-width: 767px)') && (mutation.target.classList.contains('state-visible') || targetNode.classList.contains('state-visible'))) {
							disableBodyScroll(mutation.target);
						} else {
							enableBodyScroll(mutation.target);
						}
					}
				}
			};

			const observer = new MutationObserver(callback);
			observer.observe(secondaryTargetNode, config);
		}


		// Init sub-navigation
		function closeAllSubNav(e: Event) {
			let $allSubNav = $('.js-sub-nav');
			let $target;
			let $closestSubnav;

			if(e) {
				$target = $(e.target);
				$closestSubnav = $target.closest('.js-sub-nav');

				if (e.type === 'click' && $closestSubnav.length) {
					return;
				}
			}

			if ($allSubNav.filter('.state-visible').length) {
				$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
				$allSubNav.removeClass('state-visible');
				$('body').removeClass('state-nav-open');
			}

			// Cancel the delayed mouseenter handler if it has been set
			$('.js-sub-nav-trigger').data('hovered', false);
		}

		if($('.hero-image--absolute').length) {
			$mainNav.addClass('main-nav--reversed');
			$('.js-header-search').addClass('quick-search-box--reversed');
			$('.site-header__nav-toggle').addClass('site-header__nav-toggle--reversed');
		}

		//toggle mobile nav
		let mobileTrigger = document.querySelector('.js-main-nav-toggle');
		mobileTrigger.addEventListener('click', () => {
			let siteNav = document.querySelector('.js-site-nav');
			let searchNav = document.querySelector(".js-search-container");
			let searchToggle = document.querySelector('.js-mobile-search-toggle');
			searchToggle.classList.remove('state-open');
			document.body.classList.remove('state-quick-search-open');

			if(siteNav.classList.contains('state-visible')) {
				siteNav.classList.remove('state-visible');
			} else {
				siteNav.classList.add('state-visible');
				searchNav.classList.remove('state-visible');
			}
		});

		if (isTouchDevice()) {
			// Desktop tap-on / tap-off operation
			$('.js-sub-nav-trigger').on('click', function (e) {
				let $this = $(this);
				if (!$this.hasClass('state-sub-nav-open') || $(e.target).is('.js-sub-nav-mobile-trigger')) {
					e.preventDefault();
					e.stopPropagation(); // Prevent this event from bubbling and triggering the close handler
				} else {
					$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
				}

				// Hide other open navs and show this nav
				$('.js-sub-nav-trigger').not(this).removeClass('state-sub-nav-open');
				$(this).toggleClass('state-sub-nav-open');

				let $closestSubNav = $(this).closest('.js-main-nav-item').find('.js-sub-nav');
				$closestSubNav.toggleClass('state-visible');
				$('.js-sub-nav').not($closestSubNav).removeClass('state-visible');
			});

			// Desktop tap-to-close
			$('.js-sub-nav-close').on('click', function(e) {
				$('.js-sub-nav-trigger').removeClass('state-sub-nav-open');
				$('.js-sub-nav').removeClass('state-visible');
			});

			// Mobile expand/collapse operation
			$('.js-sub-nav-mobile-trigger').on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();

				var $trigger = $(this).closest('.js-sub-nav-trigger');
				// Hide other open navs and show this nav
				$('.js-sub-nav-trigger').not($trigger).removeClass('state-sub-nav-open');
				$trigger.toggleClass('state-sub-nav-open');

				let $closestSubNav = $trigger.closest('.js-main-nav-item').find('.js-sub-nav');

				if($closestSubNav.hasClass('state-visible')) {
					$closestSubNav.removeClass('state-visible');
				} else {
					$closestSubNav.addClass('state-visible');
				}

				let $allOtherSubNavs = $('.js-sub-nav').not($closestSubNav);
				$allOtherSubNavs.removeClass('state-visible');

				// Scroll to selected trigger
				var siteNavTop = $('.js-site-nav').get(0).scrollTop;
				var scrollOffset = $trigger.position().top - siteNavTop;

				$siteNav.animate({
					scrollTop: scrollOffset
				}, 250);
			});

			$('body').on('click', closeAllSubNav);
		} else {
			// Delayed hover operation: the megamenu covers a lot of the screen and is easy to trigger accidentally
			// Wait 250ms and if the user is still hovering, open the nav
			$('.js-sub-nav-trigger').on('mouseenter focusin', function () {
				let linkText = $(this).text();
				$(this).data('hovered', true);

				setTimeout(() => {
					if ($(this).data('hovered')) {
						$(this).addClass('state-sub-nav-open');
						$(this).closest('.js-main-nav-item').find('.js-sub-nav').addClass('state-visible');
					}
				}, 250);


			});

			$('.js-sub-nav-trigger').on('focusout', closeAllSubNav);
			$('.js-main-nav-item').on('mouseleave', closeAllSubNav);
			$('body').on('click', closeAllSubNav);
		}

		let mobileSearchIcon = document.querySelector('.js-mobile-search-toggle');

		mobileSearchIcon.addEventListener('click', () => {
			let siteSearchContainer = document.querySelector('.js-search-container');
			let searchInput:HTMLElement =  document.querySelector('.secondary-nav__search-input');
			let siteNav = document.querySelector('.js-site-nav');

			if(mobileSearchIcon.classList.contains('state-open')) {
				mobileSearchIcon.classList.remove('state-open');
				siteSearchContainer.classList.remove('state-visible');
				document.body.classList.remove('state-quick-search-open');
			} else {
				mobileSearchIcon.classList.add('state-open');
				siteSearchContainer.classList.add('state-visible');
				siteNav.classList.remove('state-visible');
				searchInput.focus();
				document.body.classList.add('state-quick-search-open');
			}
		});
	}

	/**
	 * Class Method for Rendering Breadcrumbs
	 */
	export const init = () => {
		setupNav();
	}
}
